<!-- @format -->

<template>
	<div style="width: 100%">
		<el-input :model-value="value?.toString()" @click="onShow"></el-input>
		<pc-dialog
			v-model="visible"
			destroy-on-close
			:close-on-click-modal="false"
			title="关联模型"
			width="800px"
			@on-cancel="onCancel"
			@on-confirm="onConfirm"
			@close="onCancel"
		>
			<el-select
				multiple
				:model-value="linkFieldsValue"
				:teleported="false"
				class="selectUserClass"
				popper-class="selectUserPopper"
				@remove-tag="onRemove"
			/>
			<pcp-res-table
				:res-item="options.resItem"
				name="modelLink"
				:disabled="true"
				:table-props="tableProps"
				:params="{ bussinessCode }"
				@callback="() => {}"
			/>
		</pc-dialog>
	</div>
</template>

<script setup lang="ts">
	import { getCheckRowsToFormDatas, getFormDatasToStrArr, getStrArrToFormDatas } from '../utils/user';
	import { PcDialog } from '@/components';
	import { PcpResTable } from '@/p-components';
	import { flatArr } from '@/utils';

	interface Props {
		modelValue: string | null;
		options: any;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: null,
	});

	const emit = defineEmits(['update:modelValue']);

	const setFieldsValue = inject<(fields: Record<string, any>) => void>('setFieldsValue', () => {});
	const widgetDatas = inject<any[]>('widgetDatas', []);
	const formDatas = inject<any>('formDatas', {});
	const bussinessCode = inject<string>('bussinessCode', '');

	const visible = ref<boolean>(false);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const linkFieldsValue = ref<string[]>([]);

	const flatWigetDatas = computed(() => flatArr(widgetDatas || []));

	const onShow = () => {
		visible.value = true;
		const list = getFormDatasToStrArr(props.options.linkConfig, flatWigetDatas.value, formDatas.value);
		linkFieldsValue.value = list;
	};

	const onSelect = (checkRows) => {
		if (checkRows.length) {
			const formDatas = getCheckRowsToFormDatas(
				props.options.linkConfig,
				flatWigetDatas.value,
				checkRows.map((i) => i.fieldMap),
			);
			const values = getFormDatasToStrArr(props.options.linkConfig, flatWigetDatas.value, formDatas);

			const list = Array.from(new Set([...linkFieldsValue.value, ...values]));
			linkFieldsValue.value = list;
		}
	};

	const onRemove = (e) => {
		linkFieldsValue.value = linkFieldsValue.value.filter((i) => i !== e);
	};

	const onConfirm = (callback) => {
		const fields = getStrArrToFormDatas(props.options.linkConfig, flatWigetDatas.value, linkFieldsValue.value);
		setFieldsValue && setFieldsValue(fields);
		callback();
		visible.value = false;
	};

	const onCancel = (callback) => {
		callback && callback();
		visible.value = false;
	};

	const tableProps = {
		onSelect,
	};
</script>

<style lang="scss" scoped>
	.selectUserClass {
		width: 100%;
		margin-bottom: 10px;

		:deep(.selectUserPopper) {
			visibility: hidden;
		}
	}
</style>
